import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDuzgWZJU8vlVD4BvHNXolGbxXOLNHt9qU",
  authDomain: "mikerry-wedding.firebaseapp.com",
  projectId: "mikerry-wedding",
  storageBucket: "mikerry-wedding.firebasestorage.app",
  messagingSenderId: "242578162172",
  appId: "1:242578162172:web:4618a0458c3aa22f31f279"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Initialize Firebase Cloud Messaging and get a reference to the service
let messaging = null;
if (typeof window !== 'undefined' && 'Notification' in window) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn('Firebase Messaging initialization error:', error);
  }
}

export { messaging, getToken, onMessage };
export default app; // Export Firebase app